module.exports = __webpack_public_path__ + "img/logo.c839d877.png";